import { render, staticRenderFns } from "./CalcDetail.vue?vue&type=template&id=708a4f00"
import script from "./CalcDetail.vue?vue&type=script&lang=js"
export * from "./CalcDetail.vue?vue&type=script&lang=js"
import style0 from "./CalcDetail.vue?vue&type=style&index=0&id=708a4f00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports